var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#arrow-right';
                    var viewUrl = 'svg/icons.svg#view-arrow-right';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };